import createModel, { prop } from './lib/create_model';

const DEFAULT_MINIMUM_PASSWORD_LENGTH = 8;

const PasswordConfiguration = createModel({
  modelName: 'PasswordConfiguration',
  properties: {
    minimumPasswordLength: prop(Number).default(DEFAULT_MINIMUM_PASSWORD_LENGTH),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
    DEFAULT_MINIMUM_PASSWORD_LENGTH,
  },
});

export default PasswordConfiguration;
